/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.4.0-nightly.2026.6.22",
    versionName: "0.4.0-nightly.2026.6.22",
    versionChannel: "nightly",
    buildDate: "2026-06-22T00:39:59.093Z",
    commitHash: "517de6c88a7d0054a2c05e184dccedadc9544a70",
};
